import { IconProps } from './'

export function CameraIcon({
  width = 18,
  height = 18,
  color = 'currentColor',
  ...props
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      aria-hidden
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M9 12C10.2426 12 11.25 10.9926 11.25 9.75C11.25 8.50736 10.2426 7.5 9 7.5C7.75736 7.5 6.75 8.50736 6.75 9.75C6.75 10.9926 7.75736 12 9 12Z'
        fill={color}
      />
      <path
        d='M15 3.75H12.6225L11.6925 2.7375C11.415 2.43 11.01 2.25 10.59 2.25H7.41C6.99 2.25 6.585 2.43 6.3 2.7375L5.3775 3.75H3C2.175 3.75 1.5 4.425 1.5 5.25V14.25C1.5 15.075 2.175 15.75 3 15.75H15C15.825 15.75 16.5 15.075 16.5 14.25V5.25C16.5 4.425 15.825 3.75 15 3.75ZM9 13.5C6.93 13.5 5.25 11.82 5.25 9.75C5.25 7.68 6.93 6 9 6C11.07 6 12.75 7.68 12.75 9.75C12.75 11.82 11.07 13.5 9 13.5Z'
        fill={color}
      />
    </svg>
  )
}
